"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormDestinationPicker = void 0;

var _debounce2 = _interopRequireDefault(require("lodash/debounce"));

var _react = _interopRequireWildcard(require("react"));

var _formik = require("formik");

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _constants = require("../../constants");

var _constants2 = require("../DestinationPicker/constants");

var _context = require("../../context");

var _DestinationPicker = _interopRequireDefault(require("../DestinationPicker"));

var _utils = require("../../utils");

var _platformUtils = require("../../../../utils/platformUtils");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var FormDestinationPicker = function FormDestinationPicker(_ref) {
  var name = _ref.name,
      fullOptions = _ref.fullOptions,
      startOptions = _ref.startOptions,
      foundGroupedOptions = _ref.foundGroupedOptions,
      fetchAutocomplete = _ref.fetchAutocomplete,
      fetchPlaces = _ref.fetchPlaces,
      className = _ref.className,
      searchType = _ref.searchType,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'default' : _ref$variant,
      _ref$isWidget = _ref.isWidget,
      isWidget = _ref$isWidget === void 0 ? false : _ref$isWidget,
      _ref$isOpenInitial = _ref.isOpenInitial,
      isOpenInitial = _ref$isOpenInitial === void 0 ? false : _ref$isOpenInitial,
      _ref$isWhiteLabel = _ref.isWhiteLabel,
      isWhiteLabel = _ref$isWhiteLabel === void 0 ? false : _ref$isWhiteLabel,
      isLoading = _ref.isLoading,
      setBodyLocked = _ref.setBodyLocked;

  var _useState = (0, _react.useState)(isOpenInitial),
      _useState2 = _slicedToArray(_useState, 2),
      menuIsOpenExceptWizard = _useState2[0],
      setMenuIsOpenExceptWizard = _useState2[1];

  var _useState3 = (0, _react.useState)([]),
      _useState4 = _slicedToArray(_useState3, 2),
      options = _useState4[0],
      setOptions = _useState4[1];

  var prevSearchTypeRef = (0, _react.useRef)(searchType);

  var _useField = (0, _formik.useField)(name),
      _useField2 = _slicedToArray(_useField, 3),
      value = _useField2[0].value,
      error = _useField2[1].error,
      _useField2$ = _useField2[2],
      setValue = _useField2$.setValue,
      setError = _useField2$.setError;

  var _useState5 = (0, _react.useState)(value === null || value === void 0 ? void 0 : value.label),
      _useState6 = _slicedToArray(_useState5, 2),
      inputValue = _useState6[0],
      setInputValue = _useState6[1];

  var _useField3 = (0, _formik.useField)(_constants.FIELD_NAMES.departure),
      _useField4 = _slicedToArray(_useField3, 1),
      departureValue = _useField4[0].value;

  var _useCigarette = (0, _context.useCigarette)(),
      _useCigarette$state = _useCigarette.state,
      steps = _useCigarette$state.steps,
      isWizard = _useCigarette$state.isWizard,
      isMobile = _useCigarette$state.isMobile,
      dispatch = _useCigarette.dispatch;

  var isWizardOpen = searchType === _constants.SEARCH_TYPE_NAMES.PACKAGE ? isWizard && (0, _utils.afterDepartureStep)(steps) : isWizard && (0, _utils.afterDatepickerStep)(steps);
  var menuIsOpenWizard = (0, _utils.afterDestinationStep)(steps) && !isWizardOpen;
  var menuIsOpen = isWizard ? menuIsOpenWizard : menuIsOpenExceptWizard;
  var isTrip = searchType === _constants.SEARCH_TYPE_NAMES.TRIP;
  var setGroupOptionsByIds = (0, _react.useCallback)(function (groupIds) {
    var newGroupedOptions = fullOptions.filter(function (_ref2) {
      var groupName = _ref2.groupName;
      return groupIds.includes(_constants2.linkGroupDict[groupName]);
    });
    setOptions(newGroupedOptions);
  }, [fullOptions]);
  var changeOptionsByIds = (0, _react.useCallback)(function (groupIds) {
    setGroupOptionsByIds(groupIds);

    if (isWizard) {
      dispatch((0, _context.addStep)(groupIds[0]));
    }
  }, [dispatch, isWizard, setGroupOptionsByIds]);
  (0, _react.useEffect)(function () {
    if ((0, _utils.isPopularCountriesStep)(steps) || (0, _utils.isMetaregionsStep)(steps)) {
      setGroupOptionsByIds([(0, _utils.lastStep)(steps)]);
    }

    if ((0, _utils.isDestinationStep)(steps)) {
      setOptions(startOptions);
    }
  }, [setGroupOptionsByIds, startOptions, steps]);
  (0, _react.useEffect)(function () {
    setOptions(startOptions);
  }, [startOptions]);
  (0, _react.useEffect)(function () {
    fetchPlaces((departureValue === null || departureValue === void 0 ? void 0 : departureValue.value) || '');
  }, [departureValue === null || departureValue === void 0 ? void 0 : departureValue.value, fetchPlaces]);
  (0, _react.useEffect)(function () {
    setOptions(foundGroupedOptions);
  }, [foundGroupedOptions]);
  (0, _react.useEffect)(function () {
    if (error) {
      openMenu();
    }
  }, [error]);
  /**
   * При переключении типа поиска на экскурсии нужно очистить поле, если
   * до этого в нём была опция другого типа поиска
   * И наоборот при переключении типа поиска с экскурсий на обычный
   * нужно очистить поле, т.к. иначе поиск будет не того формата
   */

  (0, _react.useEffect)(function () {
    /* TODO: LT-37919 - разрулить некорректные данные на уровне стейта */
    if (searchType === _constants.SEARCH_TYPE_NAMES.TRIP || prevSearchTypeRef.current === _constants.SEARCH_TYPE_NAMES.TRIP) {
      setInputValue(undefined);
      setValue(undefined);
    }

    prevSearchTypeRef.current = searchType;
  }, [searchType]);
  var changeHandler = (0, _react.useCallback)((0, _debounce2["default"])(function (newValue) {
    if (newValue) {
      fetchAutocomplete({
        query: newValue,
        from_city: departureValue === null || departureValue === void 0 ? void 0 : departureValue.value
      });
    }
  }, 100), [departureValue === null || departureValue === void 0 ? void 0 : departureValue.value]);

  var onInputChange = function onInputChange(currentValue, _ref3) {
    var action = _ref3.action;

    // if (!currentValue) {
    //   setOptions(startOptions);
    // }
    if (action === 'input-blur' && !_platformUtils.isTouchScreen) {
      setInputValue(value ? value.label : '');
    }

    if (action === 'input-change') {
      setInputValue(currentValue);
      /**
       * Нужно, чтобы при очищении поля на десктопе в нём не оставалось
       * ранее выбранное значение
       */

      if (!currentValue) {
        setValue(undefined);
      }
    }

    changeHandler(currentValue);
  };

  var openMenu = function openMenu() {
    if (!menuIsOpen) {
      dispatch((0, _context.addStep)(name));
      setMenuIsOpenExceptWizard(true);
      setBodyLocked === null || setBodyLocked === void 0 ? void 0 : setBodyLocked(true);
    }
  };

  var closeMenu = function closeMenu() {
    setOptions(startOptions);
    setMenuIsOpenExceptWizard(false);
    setError(undefined);
    setBodyLocked === null || setBodyLocked === void 0 ? void 0 : setBodyLocked(false);
  };

  var onChange = function onChange(newValue, _ref4) {
    var action = _ref4.action;
    if (!newValue || action === 'clear' && isMobile) return;

    if (isWizard) {
      if (searchType === _constants.SEARCH_TYPE_NAMES.PACKAGE) {
        dispatch((0, _context.addStep)(_constants.FIELD_NAMES.departure));
      } else if (searchType === _constants.SEARCH_TYPE_NAMES.HOTEL) {
        dispatch((0, _context.addStep)(_constants.FIELD_NAMES.datepicker));
      }
    }

    setValue(newValue);
    setInputValue(newValue ? newValue.label : '');
    setError(undefined);
    closeMenu();
  };

  var onKeyDown = function onKeyDown(event) {
    // Если нажимаем Enter или кнопку "Ввод" на телефоне
    if (event.key === 'Enter' || isMobile && event.key === 'Go') {
      // вызываем onChange с текущим значением, а не с фокусированным
      event.preventDefault();
      onChange(value, {
        action: 'select-option',
        option: undefined
      });
    }
  };

  if (variant === 'hotel') return null;
  return /*#__PURE__*/_react["default"].createElement(FormDestinationContainer, {
    $isWizard: isWizard,
    $isMobile: isMobile
  }, /*#__PURE__*/_react["default"].createElement(_DestinationPicker["default"], {
    options: options,
    value: value,
    inputValue: inputValue,
    onInputChange: onInputChange,
    isMobile: isMobile,
    isWizardOpen: isWizardOpen,
    isWizard: isWizard,
    menuIsOpen: menuIsOpen,
    onMenuOpen: openMenu,
    isDisabled: isWizardOpen,
    onMenuClose: closeMenu,
    onChange: onChange,
    onKeyDown: onKeyDown,
    changeOptions: isTrip ? undefined : changeOptionsByIds,
    className: className,
    searchType: searchType,
    variant: variant,
    isWidget: isWidget,
    isLoading: isLoading,
    isWhiteLabel: isWhiteLabel
  }));
};

exports.FormDestinationPicker = FormDestinationPicker;

var FormDestinationContainer = _styledComponents["default"].div.withConfig({
  displayName: "FormDestinationPicker__FormDestinationContainer",
  componentId: "sc-lxqt4z-0"
})(["", " ", ";", ""], function (_ref5) {
  var $isMobile = _ref5.$isMobile;
  return $isMobile && 'width: 100%;';
}, function (_ref6) {
  var $isWizard = _ref6.$isWizard;
  return !$isWizard && "flex: 1";
}, function (_ref7) {
  var $isMobile = _ref7.$isMobile,
      $isWizard = _ref7.$isWizard;
  return $isMobile && !$isWizard && (0, _styledComponents.css)(["display:flex;flex-direction:column;"]);
});